/**
 * @file ConsentRow.tsx
 * @description Подтверждение права на шрифт (phase19.16 Р1-7; SB99, SB103 —
 * отметка 16–20 px в строке 48, нажимается вся строка): «У меня есть право
 * использовать этот шрифт на сайте» и пояснение об ответственности.
 * Без отметки загрузка не проходит; сервер хранит, кто и когда подтвердил.
 */

import { useId } from "react";

import { Checkbox } from "../../ui/checkbox";

interface Props {
  checked: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
}

export function ConsentRow({ checked, onChange, disabled = false }: Props) {
  const noteId = useId();
  return (
    <div className="flex flex-col gap-1">
      <label className="flex min-h-12 cursor-pointer items-center gap-3 rounded-lg px-1 has-[:disabled]:cursor-not-allowed">
        <Checkbox
          checked={checked}
          disabled={disabled}
          aria-describedby={noteId}
          className="size-[18px]"
          onCheckedChange={(v) => onChange(v === true)}
        />
        <span className="type-body text-on-surface">У меня есть право использовать этот шрифт на сайте</span>
      </label>
      <p id={noteId} className="type-caption pl-1 text-on-surface-variant">
        Шрифты защищены авторским правом. Ответственность за лицензию — на магазине; мы сохраним, кто и когда подтвердил.
      </p>
    </div>
  );
}
